import { service } from '../../../../helpers/http' 

export const ActionGetDocumentTypes = ({ dispatch }, payload) => { 
    return service({
        module: 'domainDocumentType',
        action: 'getDocumentTypes',
        payload: payload
    })
}

export const ActionPostDocumentTypes = ({ dispatch }, payload) => {

    return service({
        module: 'domainDocumentType',
        action: 'postDocumentTypes',
        payload: payload
    })
    
}

export const ActionPutDocumentTypes = ({ dispatch }, payload) => {

    return service({
        module: 'domainDocumentType',
        action: 'putDocumentTypes',
        payload: payload
    })
    
}

export const ActionDeleteDocumentTypes = ({ dispatch }, payload) => {

    return service({
        module: 'domainDocumentType',
        action: 'deleteDocumentTypes',
        payload: payload
    })
    
}
